module.exports = __webpack_public_path__ + "static/media/1000061.93e409bb.png";